import { render } from "./SearchIcon.vue?vue&type=template&id=ba835668&scoped=true"
const script = {}

import "./SearchIcon.vue?vue&type=style&index=0&id=ba835668&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba835668"]])

export default __exports__